import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AssignmentCommentState {
  assignment_comments: {
    answer_id: number;
    comment: string | null;
    is_correct: boolean;
  }[];
}

const initialState: AssignmentCommentState = {
  assignment_comments: [],
};

const assignmentCommentSlice = createSlice({
  name: "assignmentComment",
  initialState,
  reducers: {
    setAssignmentComments: (
      state,
      action: PayloadAction<AssignmentCommentState>
    ) => {
      state.assignment_comments = action.payload.assignment_comments;
    },
  },
});

export const { setAssignmentComments } = assignmentCommentSlice.actions;
export default assignmentCommentSlice.reducer;
